export default {
  CacheSize: 64,
  ReaderReadAHead: 95,
  PreloadCache: 50,
  UseDisk: false,
  TorrentsSavePath: '',
  RemoveCacheOnDrop: false,
  ForceEncrypt: false,
  RetrackersMode: 1,
  TorrentDisconnectTimeout: 30,
  EnableDebug: false,
  EnableDLNA: false,
  FriendlyName: '',
  EnableRutorSearch: false,
  EnableIPv6: false,
  DisableTCP: false,
  DisableUTP: false,
  DisableUPNP: false,
  DisableDHT: false,
  DisablePEX: false,
  DisableUpload: false,
  DownloadRateLimit: 0,
  UploadRateLimit: 0,
  ConnectionsLimit: 25,
  PeersListenPort: 0,
  ResponsiveMode: false,
  SslPort: 0,
  SslCert: '',
  SslKey: '',
  EnableFUSE: false,
  FUSEPath: '/mnt/torrserver',
}
